/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as OnramperRouteImport } from './../routes/onramper'
import { Route as AuthenticatedRouteImport } from './../routes/_authenticated'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as StreamIdRouteImport } from './../routes/stream.$id'
import { Route as StoreHandleRouteImport } from './../routes/store.$handle'
import { Route as PostIdRouteImport } from './../routes/post.$id'
import { Route as MeetIdRouteImport } from './../routes/meet.$id'
import { Route as ConferenceIdRouteImport } from './../routes/conference.$id'
import { Route as ChannelHandleRouteImport } from './../routes/channel.$handle'
import { Route as AuthenticatedReportsRouteImport } from './../routes/_authenticated.reports'
import { Route as AuthenticatedFavoritesRouteImport } from './../routes/_authenticated.favorites'
import { Route as AuthenticatedMeetingIdRouteImport } from './../routes/_authenticated.meeting.$id'
import { Route as AuthenticatedLivestreamIdRouteImport } from './../routes/_authenticated.livestream.$id'

const OnramperRoute = OnramperRouteImport.update({
  id: '/onramper',
  path: '/onramper',
  getParentRoute: () => rootRouteImport,
})
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
})
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
})
const StreamIdRoute = StreamIdRouteImport.update({
  id: '/stream/$id',
  path: '/stream/$id',
  getParentRoute: () => rootRouteImport,
})
const StoreHandleRoute = StoreHandleRouteImport.update({
  id: '/store/$handle',
  path: '/store/$handle',
  getParentRoute: () => rootRouteImport,
})
const PostIdRoute = PostIdRouteImport.update({
  id: '/post/$id',
  path: '/post/$id',
  getParentRoute: () => rootRouteImport,
})
const MeetIdRoute = MeetIdRouteImport.update({
  id: '/meet/$id',
  path: '/meet/$id',
  getParentRoute: () => rootRouteImport,
})
const ConferenceIdRoute = ConferenceIdRouteImport.update({
  id: '/conference/$id',
  path: '/conference/$id',
  getParentRoute: () => rootRouteImport,
})
const ChannelHandleRoute = ChannelHandleRouteImport.update({
  id: '/channel/$handle',
  path: '/channel/$handle',
  getParentRoute: () => rootRouteImport,
})
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedFavoritesRoute = AuthenticatedFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedMeetingIdRoute = AuthenticatedMeetingIdRouteImport.update({
  id: '/meeting/$id',
  path: '/meeting/$id',
  getParentRoute: () => AuthenticatedRoute,
})
const AuthenticatedLivestreamIdRoute =
  AuthenticatedLivestreamIdRouteImport.update({
    id: '/livestream/$id',
    path: '/livestream/$id',
    getParentRoute: () => AuthenticatedRoute,
  })

const AuthenticatedRouteChildren = {
  AuthenticatedFavoritesRoute: AuthenticatedFavoritesRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedLivestreamIdRoute: AuthenticatedLivestreamIdRoute,
  AuthenticatedMeetingIdRoute: AuthenticatedMeetingIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  OnramperRoute: OnramperRoute,
  ChannelHandleRoute: ChannelHandleRoute,
  ConferenceIdRoute: ConferenceIdRoute,
  MeetIdRoute: MeetIdRoute,
  PostIdRoute: PostIdRoute,
  StoreHandleRoute: StoreHandleRoute,
  StreamIdRoute: StreamIdRoute,
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)
